import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { AutoCompleteGeneric } from "src/Pages/components/InputAutoCompleted/AutoCompleteGeneric";
import { IPropsAutoCompleted } from "src/Pages/components/InputAutoCompleted/types";

export const AutoCompleteGerenteReports = (props: IPropsAutoCompleted) => {
  const {
    disabled,
    label,
    width,
    tamanho,
    minWidth,
    maxWidth,
    fullWidth,
    placeholder,
    tooltip,
    variant,
  } = props;

  const { setValueAutoCompGerente, valueAutoCompGerente } =
    UseAutoCompletedAll();

  return (
    <AutoCompleteGeneric
      disabled={disabled}
      fullWidth={fullWidth}
      label={label}
      maxWidth={maxWidth}
      minWidth={minWidth}
      placeholder={placeholder}
      setValueAutoCompleted={setValueAutoCompGerente}
      tamanho={tamanho}
      tooltip={tooltip}
      url="/getAllProdutores?funcao_produtor=GERENTE"
      valueAutoCompleted={valueAutoCompGerente}
      variant={variant}
      width={width}
    />
  );
};
